import React, { useEffect, useState } from 'react';
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Flex, theme } from 'antd';

export const SUCCESS_VISIBLE_MS = 2000;

export type SaveStatus = 'idle' | 'saving' | 'success' | 'error';

type SaveIndicatorProps = {
  status: SaveStatus;
  onRetry?: () => void;
};

function SaveIndicator({ status, onRetry }: SaveIndicatorProps) {
  const { token } = theme.useToken();
  const [successVisible, setSuccessVisible] = useState(false);

  useEffect(() => {
    if (status !== 'success') {
      setSuccessVisible(false);
      return undefined;
    }

    setSuccessVisible(true);
    const timer = setTimeout(() => setSuccessVisible(false), SUCCESS_VISIBLE_MS);
    return () => clearTimeout(timer);
  }, [status]);

  if (status === 'saving') {
    return <LoadingOutlined />;
  }

  if (status === 'success' && successVisible) {
    return <CheckCircleOutlined style={{ color: token.colorSuccess }} />;
  }

  if (status === 'error') {
    return (
      <Flex align="center" gap={token.marginXS}>
        <CloseCircleOutlined style={{ color: token.colorError }} />
        <Button type="link" onClick={onRetry} style={{ paddingInline: 0 }}>
          Retry
        </Button>
      </Flex>
    );
  }

  return null;
}

export default SaveIndicator;
